import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs';
import { IndirizzoDTO } from '../../../models/indirizzo-dto';
import { LocalitaDTO } from '../../../models/localita-dto';
import { Localita } from '../../../models/portale/localita';
import { StradaDTO } from '../../../models/strada-dto';
import { ComponentOutputStatus } from '../../../normalizzazione/component-output-status';
import { MessageService } from '../../../services/message.service';
import { ComponentReducer } from '../../../utils/component-reducer';

@Component({
	selector: 'lib-indirizzo-italiano',
	templateUrl: './indirizzo-italiano.component.html',
	styleUrls: ['./indirizzo-italiano.component.css']
})
export class IndirizzoItalianoComponent implements OnInit {

	@Input()
	indirizzo: IndirizzoDTO;

	@Input()
	viewOnly: boolean;

	@Input()
	province: Observable<Array<Localita>>;

	@Output()
	done: EventEmitter<ComponentOutputStatus<IndirizzoDTO>> =
		new EventEmitter<ComponentOutputStatus<IndirizzoDTO>>();

	@Input()
	namespace: string;

	namespaceStrada: string;
	namespaceLoc: string;
	form: FormGroup;
	changesStrada$ = new Subject<ComponentOutputStatus<(value: IndirizzoDTO) => void>>();
	changesLocalita$ = new Subject<ComponentOutputStatus<(value: IndirizzoDTO) => void>>();

	indirizzoChangedSub: Subscription;

	constructor(private msg: MessageService) { }

	ngOnInit() {
		this.form = new FormGroup({});
		let valid = true;
		if (!this.indirizzo) {
			this.indirizzo = new IndirizzoDTO();
			valid = false;
		}
		this.namespaceStrada = this.namespace + 'strada';
		this.namespaceLoc = this.namespace + 'loc';

		const indirizzoChanged$ = ComponentReducer.reducer2(
			this.changesStrada$,
			this.changesLocalita$,
			ind => ind.localita != null && ind.strada != null,
			ComponentOutputStatus.of(valid, this.indirizzo)
		);


		this.indirizzoChangedSub = indirizzoChanged$.
			subscribe((newIndirizzo: ComponentOutputStatus<IndirizzoDTO>) => {
				this.done.emit(newIndirizzo);
			});
	}

	localitaReady(localitaStatus: ComponentOutputStatus<LocalitaDTO>) {
		this.changesLocalita$.next(localitaStatus.mapValue(localita => (ind: IndirizzoDTO) => ind.localita = localita));
	}

	stradaReady(stradaStatus: ComponentOutputStatus<StradaDTO>) {
		this.changesStrada$.next(stradaStatus.mapValue(strada => (ind: IndirizzoDTO) => ind.strada = strada));
	}

}
